import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import {COMMON_NAMESPACE, CUSTOMER_SUPPORT_NAMESPACE} from "../../../../utils/i18nNameSpaces";
import {HR_GROUP, HR_SOFTWARE, SOFTWARE_PHONE} from "../../../../utils/constants";
import img1 from "/public/contactus/officesImgs/_1.png";
import img2 from "/public/contactus/officesImgs/_2.png";
import img3 from "/public/contactus/officesImgs/_3.png";
import img4 from "/public/contactus/officesImgs/_4.png";
import Phone from "../../../common/components/Icons/Common/Phone";
import Mail from "../../../common/components/Icons/Common/Mail";
import Image from "next/image";
import Link from "next/link";
import cn from "classnames";
import ImageGallery from "react-image-gallery";
import GalleryOpen from "../../../common/components/Icons/Common/GalleryOpen";
import {images_nd64, images_nezalezhnoi65, images_northern4, images_sedova8} from "../images";
import Portal from "../../../../helpers/hocs/Portal";
import useMobile from "../../../../helpers/hooks/useMobile";
import {useRouter} from "next/router";
import {toBase64} from "../../../../helpers/toBase64";
import {shimmer} from "../../../common/components/FeaturesTemplate/FeatureImg";

const northern4 = "//umap.openstreetmap.fr/en/map/devit-office-northern4_785193";
const nd64 = "//umap.openstreetmap.fr/en/map/devit-office-nb64_784832";
const sedova8 = "//umap.openstreetmap.fr/en/map/devit-office-sedova8_785196";
const nezalezhnoi65 = "//umap.openstreetmap.fr/en/map/devit-office-nezalezhnoi65_785198";

const mapList = [
  nd64,
  northern4,
  sedova8,
  nezalezhnoi65
]

const gallery = [
  images_nd64,
  images_northern4,
  images_sedova8,
  images_nezalezhnoi65
]

export const CONTACT_US_GALLERY_ID = "contact-gallery";
export const loadingAnimation = (w, h, strokeW = 10) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <rect width="${w}" height="${h}" fill="#3a3b3d" />
  <rect id="r" width="${strokeW}" height="${h}" fill="#fff" />
  <animate xlink:href="#r" attributeName="x" from="-20" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`

const Index = () => {
  const {t} = useTranslation(CUSTOMER_SUPPORT_NAMESPACE);
  const [activeCard, setActiveCard] = useState(0);
  const [isGalleryActive, setIsGalleryActive] = useState(false);
  const [activeGallery, setActiveGallery] = useState(0);

  const galleryMobile = useMobile(767);
  const mapMobile = useMobile(570);
  const mapRef = useRef(null);

  const map = useMemo(() => (
    <iframe id={"map"} width="100%" height={mapMobile ? "300px" : "500px"} ref={mapRef} frameBorder="0" allowFullScreen
            src={`${mapList[activeCard]}?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=false&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=undefined&captionBar=false`}></iframe>
  ), [activeCard, mapMobile])
  const items = [
    {
      original: <Image src={img4}/>,
      thumbnail: <Image src={img4}/>
    },
    {
      original: <Image src={img4}/>,
      thumbnail: <Image src={img4}/>
    },
    {
      original: <Image src={img4}/>,
      thumbnail: <Image src={img4}/>
    }
  ]
  const scrollToMap = useCallback(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.scrollBy(0, mapRef.current.getBoundingClientRect().top - 92);
  }, [mapRef])

  const cards = useMemo(() => {
    const cardList = [
      {
        header: t(`${COMMON_NAMESPACE}:departments.software`),
        office: t(`${COMMON_NAMESPACE}:offices.nd64`),
        phone: {
          pretty: SOFTWARE_PHONE.pretty,
          code: SOFTWARE_PHONE.code
        },
        email: HR_SOFTWARE,
        img: img1
      },
      {
        header: t(`${COMMON_NAMESPACE}:departments.outsource`),
        office: t(`${COMMON_NAMESPACE}:offices.northern4`),
        phone: {
          pretty: "+38 (066) 30 63 310",
          code: "+380663063310"
        },
        email: HR_GROUP,
        img: img2
      },
      {
        header: t(`${COMMON_NAMESPACE}:departments.outsource`),
        office: t(`${COMMON_NAMESPACE}:offices.sedova8`),
        phone: {
          pretty: "+38 (066) 30 63 310",
          code: "+380663063310"
        },
        email: HR_GROUP,
        img: img3
      },
      {
        header: t(`${COMMON_NAMESPACE}:departments.academy`),
        office: t(`${COMMON_NAMESPACE}:offices.nezalezhnoi65`),
        phone: {
          pretty: "+38 (066) 30 63 310",
          code: "+380663063310"
        },
        email: HR_GROUP,
        img: img4
      }
    ]

    return (
      <ul className={styles["cards-list"]}>
        {cardList.map((el, i) => (
          <li key={i} className={cn(styles["card"], {[styles["card--active"]]: activeCard === i})}>
            <div
              className={styles["card-content"]}
              onClick={() => {
                setActiveCard(i);
                scrollToMap();
              }}>
              <p className={styles["card-office"]}>{t(`${COMMON_NAMESPACE}:office`)} #{i + 1}</p>
              <p className={styles["card-header"]}>{el.header}</p>
              <p className={styles["card-office"]}>{el.office}</p>
              <div className={styles["links-wrapper"]}>
                <div className={styles["card-link"]}>
                  <div className={styles["card-icon-link"]}>
                    <Phone/>
                  </div>
                  <Link href={`tel:${el.phone.code}`}>
                    <a>{el.phone.pretty}</a>
                  </Link>
                </div>
                <div className={styles["card-link"]}>
                  <div className={styles["card-icon-link"]}>
                    <Mail/>
                  </div>
                  <Link href={`mailto:${el.email}`}>
                    <a>{el.email}</a>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className={styles["card-img-wrapper"]}
              onClick={() => {
                setIsGalleryActive(true);
                setActiveGallery(i)
              }}>
              <div className={styles["gallery-open-wrapper"]}>
                <GalleryOpen/>
              </div>
              <Image src={el.img}/>
            </div>
          </li>
        ))}
      </ul>
    )
  }, [activeCard, t, mapMobile])
  const renderItem = useCallback(a => {
    return (
      <div className={styles["gallery-img-wrapper"]}>
        <Image src={a.original} layout="fill" objectFit="contain" placeholder="blur" blurDataURL={`data:image/svg+xml;base64,${toBase64(
          loadingAnimation(800, 600)
        )}`}/>
      </div>
    )
  }, [])
  const renderThumbInner = useCallback(a => {
    return (
      <div className={styles["gallery-img-wrapper-thumbnail"]}>
        <Image src={a.thumbnail} layout="fill" objectFit="contain" placeholder="blur" blurDataURL={`data:image/svg+xml;base64,${toBase64(
          loadingAnimation(92, 62, 2)
        )}`}/>
      </div>
    )
  }, [])
  return (
    <div className={styles["footer"]}>
      <div className={styles["container"]}>
        {isGalleryActive &&
          <>
            <div className={styles["overlay"]} onClick={() => setIsGalleryActive(false)}/>
            <div className={styles["gallery-wrapper"]}>
              <div className={styles["sidebar__close-wrapper"]}>
                <button className={styles["sidebar__close"]} onClick={() => setIsGalleryActive(false)}>
                  <div className={styles["sidebar__close-stick"]}/>
                </button>
              </div>
              <div className={styles["gallery"]}>
                <ImageGallery
                  items={gallery[activeGallery]}
                  originalAlt={"Office image"}
                  thumbnailAlt={"Office image"}
                  showPlayButton={false}
                  showFullscreenButton={false}
                  useBrowserFullscreen={false}
                  thumbnailPosition={galleryMobile ? "bottom" : "left"}
                  renderItem={renderItem}
                  renderThumbInner={renderThumbInner}
                />
              </div>
            </div>
          </>
        }
        <div>
          {cards}
        </div>
        <div className={styles["img-wrapper"]}>
          {map}
        </div>
      </div>
    </div>
  );
};

export default Index;